import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {autoSubmitForm} from "./common/auto-submit-form";

export const ProcurementApproval = ({disabled, cart, next}) => cs(
    ["procurementItem", (_, next) => next(disabled ? null : cart.items.find((i) => i.approvalInfo?.approvalType === "procurement"))],
    consumeContext("apis"),
    ({procurementItem, apis}) => {
        return next(!procurementItem ? (
            null
        ) : {
            submitRequest: async () => {
                const result = await apis.next.approval.processProcurement(cart.cartId);
                if (result.transmissionType === "http") {
                    autoSubmitForm(extractForm(result.procurement));
                } else if (result.transmissionType === "ftp") {
                    window.location.href = result.redirectUrl;
                } else {
                    alert(result.errors.msg);
                }
            },
        });
    },
);

const extractForm = (html) => {
    return html.substring(
        html.indexOf("<form"),
        html.lastIndexOf("</form>") + "</form>".length
    );
};

